import React from "react";

import "../css/AboutMe.css";

const AboutMe = () => {
  return <div className="about-me">
    <h1>About Me</h1>
    <p>
    Highly motivated and results-oriented Engineer with 20 years of experience in developing and
    implementing automated production systems. Proven track record of success in driving operational efficiency
    and cost savings through innovative automation solutions. Expertise in project management, process
    improvement, and leading cross-functional teams. Strong analytical and problem-solving skills with a focus
    on continuous improvement. Black Belt certified with extensive experience in Lean Manufacturing and Six
    Sigma methodologies. Recently certified as a MERN Full Stack Developer, expanding skills into software
    development and cloud computing.
    </p>
  </div>;
};

export default AboutMe;
